import React, { Component } from 'react'
import BreadcrumbBar from '../../../components/breadcrumbBar'
import Videos from './videos'

export default class WarrantVideos extends Component { 
    render() {
        return (
            <div id="dwvideo" className="pageobj">
                <BreadcrumbBar link="/home/edu" group="Warrant education" title="All videos" />
                <div className="stripe-bg"></div>
                <div className="container-fluid">
                    <div className="section">
                        <div className="page-header">
                            <h2>All videos</h2>
                        </div>
                        <p className="section-p">
                            This section has a video playlist for Market View where you can hear from market experts about stocks/indices to watch in the short-term!
                            The Warrant tutorial video section contains demonstrations of how to use the various warrant tools on our website to help improve your warrant trading.
                            Watch them all now!
                        </p>
                        <Videos />
                    </div>
                </div>
            </div>
        )
    }
}
